import axios from "axios";
import TokenService from "../services/token.service";

const login = (username, password) => {
  const param = { UserName: username, Password: password, Role: "" };

  return axios
    .post(globalThis.config.Settings.ApiConfiguration.Host +
      globalThis.config.Settings.ApiConfiguration.Microservices.Common + 'api/Authenticate/Authenticate', param)
    .then((response) => {
      if (response.data.jwtToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
        TokenService.setUser(response.data);
      }
      return response.data;
    }).catch(error => {
      setError(error);
    });
};

const logout = () => {
  localStorage.removeItem("user");
  TokenService.removeUser();
};

export default {
  login,
  logout,
};
